// Jobtype mapping (backend → frontend)
export const JOB_TYPE_BE_TO_FE_MAP: Record<string, string> = {
  "Fully remote": "Remote",
  Hybrid: "Hybrid",
  "On site": "On-Site",
};
